var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8337 9.99967H6.66732C4.82637 9.99967 3.33398 11.4921 3.33398 13.333V14.9997C3.33398 16.8407 4.82637 18.333 6.66732 18.333H18.334V13.333C18.334 12.4125 19.0802 11.6663 20.0007 11.6663C20.9212 11.6663 21.6673 12.4125 21.6673 13.333V18.333H33.334C35.175 18.333 36.6673 16.8407 36.6673 14.9997V13.333C36.6673 11.4921 35.175 9.99967 33.334 9.99967H29.1677C29.6907 9.30329 30.0007 8.43767 30.0007 7.49967C30.0007 5.19849 28.1352 3.33301 25.834 3.33301H25.498C24.1301 3.33301 22.8367 3.95477 21.9822 5.02286L20.0007 7.49967L18.0192 5.02286C17.1647 3.95477 15.8711 3.33301 14.5033 3.33301H14.1673C11.8661 3.33301 10.0007 5.19849 10.0007 7.49967C10.0007 8.43767 10.3106 9.30329 10.8337 9.99967ZM15.4163 7.10517L16.3986 8.33301H14.1673C13.7071 8.33301 13.334 7.95991 13.334 7.49967C13.334 7.03944 13.7071 6.66634 14.1673 6.66634H14.5033C14.8585 6.66634 15.1944 6.82781 15.4163 7.10517ZM23.6026 8.33301L24.585 7.10517C24.8068 6.82781 25.1428 6.66634 25.498 6.66634H25.834C26.2942 6.66634 26.6673 7.03944 26.6673 7.49967C26.6673 7.95991 26.2942 8.33301 25.834 8.33301H23.6026Z",
    fill: "#39BD86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 21.667H6.66667C5.81348 21.667 5 22.288 5 23.1412V31.667C5 34.4283 7.23858 36.667 10 36.667H18.3333V21.667Z",
    fill: "#39BD86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.666 36.667H29.9993C32.7608 36.667 34.9993 34.4283 34.9993 31.667V23.1412C34.9993 22.288 34.1858 21.667 33.3327 21.667H21.666V36.667Z",
    fill: "#39BD86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurprise);
export default __webpack_public_path__ + "static/media/surprise.2cce63406a4dfea4537140f2d26da261.svg";
export { ForwardRef as ReactComponent };